import { render, staticRenderFns } from "./CatalogItemsPage.vue?vue&type=template&id=3a1f6b94&scoped=true"
import script from "./CatalogItemsPage.vue?vue&type=script&lang=js"
export * from "./CatalogItemsPage.vue?vue&type=script&lang=js"
import style0 from "./CatalogItemsPage.vue?vue&type=style&index=0&id=3a1f6b94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f6b94",
  null
  
)

export default component.exports